import {Component, effect, HostListener, signal, ViewChild, WritableSignal,} from '@angular/core';
import {
    DraftStatus,
    FileCase,
    ProyectoCreadoItem,
    RequisitosFormulario,
    TenenciaItem,
} from '../../../interfaces/proyecto.interface';
import {ConfirmationService, ConfirmEventType, MessageService} from 'primeng/api';
import {NuevoProyectoService} from './services/nuevo-proyecto.services';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from '@angular/router';
import {filter, Observable} from 'rxjs';
import {TramiteService} from "../../../tramites/services/tramite.service";
import {UbicacionService} from "./services/ubicacion.service";
import {LoginServices} from "../../../../auth/login/services/login.service";
import {UserSessionReq} from "../../../../shared/interfaces/user-session-req-interface";
import {PersonasService} from "../../../../shared/services/personas-service";
import {FileQueueItem} from "../../../../shared/interfaces/file-utils-interface";
import {FileUtilsService} from "../../../../shared/services/file-utils-service";
import {RandomSessionIdService} from "../../../../guards/random-session-id.service";
import {SdetTramiteService} from "../../../tramites/services/sdet-tramite.service";
import {FrmService} from "../../../../shared/services/frm-service";
import {FrmPasoItem} from "../../../../shared/interfaces/shared-interface";
import Swal from "sweetalert2";
import {isValidNumber, isValidObject, isValidText, isValidUbicacion} from "../../../../shared/services/utils-service";
import {FieldPersonas, Options} from "../../../../shared/interfaces/personas-proyecto.interface";
import {FormGroup} from "@angular/forms";
import {PasosPersonasService} from "./services/pasos-personas.service";
import {
    FormGroupBuilderService
} from "../../../../shared/components/solicitud-requisitos/rq-form/services/form-group-builder.service";
import {
    FieldsParserService
} from "../../../../shared/components/solicitud-requisitos/rq-form/services/fields-parser.service";
import {DraftProjectService} from "../../services/draft-project.service";
import {FileUpload} from "primeng/fileupload";
import {ProyectoPerfil} from "../../../interfaces/perfil.interface";

@Component({
    selector: 'app-nuevo-proyecto',
    templateUrl: './nuevo-proyecto.component.html',
    styleUrls: ['./nuevo-proyecto.component.css'],
    providers: [ConfirmationService, MessageService]
})
export class NuevoProyectoComponent {

    stepComponents = []
    /*
     Inicio de variables
     */
    idProyecto: number | null = null
    //Variables para el manejo de los componentes dentro del paso 1
    activeIndex: WritableSignal<number> = signal(0)
    activeStep: number = 0;
    selectedComponent = this.stepComponents[this.activeStep!]!;
    stepsFU: WritableSignal<FrmPasoItem[]> = signal([])
    sessionId: string | null
    showLoader: boolean = false
    progressDialog: boolean = false
    projectSaved: boolean = false
    fileUploadCompleted: boolean = false
    //Variables para información general del proyecto
    datosCompletosInformacionGral: boolean = false
    selected: WritableSignal<ProyectoCreadoItem | null> = signal(null)
    areaTerreno: string = null!
    datosCompletosUbicacion: boolean = false
    //Variables tenencia
    tenenciaSeleccionada: TenenciaItem | null = null
    datosCompletosTenencia: boolean = false
    banderaBotonConfirmar: any | boolean = false;
    //Variables planos
    selectPlanosRequisito: RequisitosFormulario | undefined | null = null;
    //variable para recargarArchivos
    hashDelArchivo: any = null
    //variables pasos personas proyecto componente
    fields: FieldPersonas<string>[] | null = [];
    fields$: Observable<FieldPersonas<any>[]> | undefined;
    form!: FormGroup;
    //Json constantes
    dropDownTenencia: Options[] = [
        {
            key: '1',
            value: 'COMODATO',
            estado: true,
            idRequisito: 87,
            tituloFile: 'Contrato de comodato',
            tituloInfo: 'Es el documento de contrato de comodato certificado por notario'
        },
        {
            key: '2',
            value: 'ARRENDATARIO',
            estado: true,
            idRequisito: 10,
            tituloFile: 'Contrato de arrendamiento',
            tituloInfo: 'Es el documento de contrato de arrendamiento certificado por notario'
        },
        {
            key: '3',
            value: 'PROPIETARIO',
            estado: true,
            idRequisito: 14,
            tituloFile: 'Título de propiedad',
            tituloInfo: 'Es el documento de título de propiedad (escritura o sentencia) inscrita en el CNR certificada por notario'
        }
    ];
    dropDownTitulares:Options[]= [];
    dropDownProfesionales: Options[] = [
        {
            key: '4',
            value: 'Plano Topográfico',
            estado: true,
            idRequisito: 1,
            tituloFile: 'Plano topográfico',
            tituloInfo: 'Documentos de plano topográfico par el proyecto'
        }
    ]
    fieldsJsonConst: FieldPersonas<string>[] | null = [
        new FieldPersonas<string>({
            step: 2,
            titulo: 'Datos de tenencia',
            subtitulo: '',
            typeStep:'uniqueForm',
            components: [{
                key: 'tenencia',
                label: 'Tenencia del inmueble',
                placeholder: 'Seleccione la tenencia del inmueble *',
                required: true,
                disabled: false,
                completed: false,
                order: 2,
                controlType: 'dropdown',
                type: 'dropdown',
                options: this.dropDownTenencia,
                values: [],
            }
                // , {
                //     key:'comments',
                //     label:'Comentarios(Opcional)',
                //     placeholder: '',
                //     required:false,
                //     disabled:false,
                //     completed:false,
                //     order:5,
                //     controlType: 'textbox',
                //     type:'textbox',
                //     options: [],
                //     values: [],
                // }
            ],
            pieValidTable: 'Favor ingresar uno o más propietarios',
            disableComponent:false
        }),
        new FieldPersonas<string>({
            step: 3,
            titulo: 'Datos de titular y representante legal',
            subtitulo: '',
            typeStep:'uniqueForm',
            components: [
                {
                    key: 'titulares',
                    label: 'Titular',
                    placeholder: 'Seleccionar el titular *',
                    required: true,
                    disabled: false,
                    completed: false,
                    order: 1,
                    controlType: 'dropdown',
                    type: 'dropdown',
                    options: this.dropDownTitulares,
                    values: [],
                },
                {
                    key: 'representanteLegal',
                    label: '',
                    placeholder: '',
                    required: false,
                    disabled: false,
                    completed: false,
                    order: 3,
                    controlType: 'dropdown-hidden',
                    type: 'hidden',
                    options: [
                        {
                            key: '5',
                            value: 'REPRESENTANTE LEGAL',
                            estado: false,
                            idRequisito: 11,
                            tituloFile: 'Contrato de comodato',
                            tituloInfo: 'Es el documento de contrato de comodato certificado por notario'
                        }
                    ],
                    values: [],
                }
            ],
            pieValidTable: 'Favor ingresar uno o más representantes',
            disableComponent:false
        }),
        new FieldPersonas<string>({
            step: 4,
            titulo: 'Datos de inversión',
            subtitulo: '',
            typeStep:'groupForm',
            components: [
                {
                    key: 'montoInversion',
                    label: 'Monto inversión',
                    placeholder: 'Ingresar el monto de inversión',
                    required: false,
                    disabled: false,
                    completed: false,
                    order: 1,
                    controlType: 'textboxNumber',
                    type: 'number',
                    options: [],
                    values: [],
                },
            ],
            pieValidTable: '',
            disableComponent:true
        }),
        new FieldPersonas<string>({
            step: 4,
            titulo: 'Datos profesional planos (Opcional)',
            subtitulo: '',
            typeStep:'groupForm',
            components: [
                {
                    key: 'profesionalesPlanos',
                    label: 'Tipo planos',
                    placeholder: 'Seleccionar el plano',
                    required: false,
                    disabled: false,
                    completed: false,
                    order: 2,
                    controlType: 'dropdown',
                    type: 'dropdown',
                    options: this.dropDownProfesionales,
                    values: [],
                }
            ],
            pieValidTable: '',
            disableComponent:false
        })
    ];
    @ViewChild('recargarArchivos') fileUpload: FileUpload | any;
    /*
     Fin de variables
     */
    constructor(private route: ActivatedRoute, private messageService: MessageService, private nuevoProyectoService: NuevoProyectoService,
                private router: Router, private loginServices: LoginServices, protected tramite: TramiteService, private confirmationService: ConfirmationService,
                private ubicacion: UbicacionService, protected personasService: PersonasService, protected fileUtilsService: FileUtilsService, protected rs: RandomSessionIdService,
                private sdetTramiteService: SdetTramiteService, private frmService: FrmService, protected pasosPersonasService: PasosPersonasService, private fgbs: FormGroupBuilderService,
                public fieldsParserService: FieldsParserService, protected draftProjectService: DraftProjectService) {
        this.sessionId = rs.randomSessionId();
       effect(() => {
           //Construir el formulario dinámico y completar la informacion que necesita el componente dropDownTitulares
           let nuevasAutorizaciones = this.pasosPersonasService.autorizaciones();

           // Solo actualizar si hay cambios en la cantidad de autorizaciones
           if (nuevasAutorizaciones.length !== this.dropDownTitulares.length - 1) {
               const titulares = this.pasosPersonasService.actualizarJsonConPersonas();
               this.dropDownTitulares.length = 0;
               this.dropDownTitulares.push(...titulares);
               this.fields$ = this.fieldsParserService.parseFieldsPersonas(this.convertToJsonString(this.fieldsJsonConst!));
               this.fields$.subscribe(fields => {
                   this.fields = fields;
                   this.form = this.fgbs.toFormGroupPersonas(this.fields as FieldPersonas<string>[]);
               });
           }
        })
    }

    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
        this.fetchStep()
        this.fetchPasosFU()
        this.pasosPersonasService.getAutorizaciones(this.loginServices.session()?.perfil.uniqueId!);
        let savedDraft = localStorage.getItem("draftProject");
        if (savedDraft) {
            this.draftProjectService.draftProject.set(JSON.parse(savedDraft));
            this.areaTerreno = this.draftProjectService.draftProject().areas?.[0]?.area?.toString() ?? '';
        }
    }

    ngOnDestroy(): void {
        console.log(`ngOnDestroy() ->` + this.constructor.name)
        this.cleanSteps()
        this.pasosPersonasService.autorizaciones.set([]);
        localStorage.removeItem("draftProject");
        this.draftProjectService.draftProject.set(this.draftProjectService.resetDratfProject());
        this.draftProjectService.checkSeleted.set(false);
    }

    //Cambio de paso
    onActiveIndexChange(event: number) {
        this.activeIndex.set(event)
        console.log("onActiveIndexChange() ->", this.activeIndex())
        this.setStep(event)
    }

    validarFormularioDatosGral() {
        this.datosCompletosInformacionGral = true;
        if (this.draftProjectService.draftProject()?.nombre != null && this.draftProjectService.draftProject()?.nombre != "" && this.draftProjectService.draftProject()?.descripcion != null && this.draftProjectService.draftProject()?.descripcion != "" &&
            this.draftProjectService.draftProject()?.idNaturaleza != null && this.draftProjectService.draftProject()?.idNaturaleza != "" && this.draftProjectService.draftProject()?.idTipoProyecto != null && this.draftProjectService.draftProject()?.idTipoProyecto != "" &&
            this.draftProjectService.draftProject()?.idEntorno != null && this.draftProjectService.draftProject()?.idEntorno != "" &&
            this.draftProjectService.draftProject()?.idTipoUsoSuelo != null && this.draftProjectService.draftProject().descripcion!.length < 2000) {
            if (this.draftProjectService.draftProject()?.idTipoProyecto != '4') {
                return true
            } else {
                if (this.draftProjectService.draftProject()?.idRegimen != null && this.draftProjectService.draftProject()?.idRegimen != "") {
                    return true
                } else {
                    return false
                }
            }
        } else {
            return false
        }
    }

    /**
     * Validar que se ingrese Ubicacion(claveCatastral y/o matrícula) o Coordenadas en paso relacionado con la ubicacion del inmueble. 20/01/2025 15:48hrs
     */
    validarFormularioUbicacion() {
        this.datosCompletosUbicacion = true;
        let u = this.draftProjectService.draftProject().ubicacionItem;
        return isValidText(this.draftProjectService.draftProject().direccion.complemento) &&
            isValidText(this.draftProjectService.draftProject().direccion.complemento2) &&
            isValidText(this.areaTerreno) &&
            isValidText(this.draftProjectService.draftProject().idRelieve!) &&
            isValidObject(this.draftProjectService.draftProject().departamento) &&
            isValidText(this.draftProjectService.draftProject().departamento.id) &&
            isValidNumber(this.draftProjectService.draftProject()?.direccion.idMunicipio) &&
            isValidObject(this.draftProjectService.draftProject().distrito) &&
            isValidNumber(this.draftProjectService.draftProject().distrito.idDistrito) && isValidObject(u)&&
            isValidText(this.draftProjectService.draftProject().ubicacionItem.matricula)&&
            isValidText(this.draftProjectService.draftProject().ubicacionItem.claveCatastral)&&
            this.draftProjectService.draftProject().direccion?.complemento.length < 1000 &&
            this.draftProjectService.draftProject().direccion?.complemento2.length < 1000;
    }

    /**
     * Tenencia legal en creacion de proyecto requiere que se especifique el propietario.
     * idTenencia = 3 --> Propierario.
     */
    validarFormularioTenencia() {
        this.datosCompletosTenencia = true
        if (this.draftProjectService.draftProject().tenenciaLegal.length != 0) {
            let tenenciaTipoPropietarioEspecificada = this.draftProjectService.draftProject().tenenciaLegal.some(prop => prop.idTenencia == 3);
            return tenenciaTipoPropietarioEspecificada;
        } else {
            return false
        }
    }
    validarFormularioRepresentanteLegal(): boolean {
        if (this.draftProjectService.draftProject().tenenciaLegal.length != 0) {
            let tenenciaRepresentanteLegal = this.draftProjectService.draftProject().tenenciaLegal.some(prop => prop.idTenencia == 5);
            return tenenciaRepresentanteLegal;
        } else {
            return false
        }
    }

    navigateStep(avanzar: boolean) {
        if (avanzar) {
            console.log(`activeIndex ->${this.activeIndex()}`)
            if (this.activeIndex() == 0) {
                if (this.activeStep == 0) {
                    let validez = this.validarFormularioDatosGral()
                    if (!validez) {
                        this.messageService.add({
                            severity: 'error',
                            summary: '',
                            detail: 'Campos requeridos pendientes'
                        });
                        return;
                    }
                    this.datosCompletosInformacionGral = !this.datosCompletosInformacionGral
                    this.activeStep = this.activeStep + 1
                } else if (this.activeStep == 1) {
                    let validez = this.validarFormularioUbicacion()
                    if (!validez) {
                        this.messageService.add({
                            severity: 'error',
                            summary: '',
                            detail: 'Campos requeridos pendientes'
                        });
                        return;
                    }
                    if (!isValidUbicacion(this.draftProjectService.draftProject().ubicacionItem)) {
                        Swal.fire({
                            icon: "error",
                            title: "Campos requeridos",
                            html: `Es requerido ingresar <b>Ubicación</b> o <b>Coordenadas</b>. <br/> Puedes ingresar cualquiera.`,
                            showDenyButton: true,
                            showConfirmButton: false,
                            denyButtonText: `Ok`
                        }).then(r => console.log('Ubicación o coordenadas invalidas'));
                        return;
                    }
                    if (this.areaTerreno == "0") {
                        this.messageService.add({
                            severity: 'error',
                            summary: '',
                            detail: 'Favor el área no puede ser cero'
                        });
                        return;
                    }
                    this.datosCompletosUbicacion = !this.datosCompletosUbicacion
                    this.activeStep = this.activeStep + 1
                } else if (this.activeStep == 2) {
                    let validez = this.validarFormularioTenencia()
                    if (!validez) {
                        console.log("validarFormularioTenencia has errors");
                        let msg = "";
                        if (this.draftProjectService.draftProject().tenenciaLegal == null || this.draftProjectService.draftProject().tenenciaLegal.length == 0) {
                            msg = "Tenencia legal es requerida"
                        } else {
                            msg = "Datos del propietario son requeridos para continuar el proceso"
                        }
                        this.messageService.add({
                            severity: 'error',
                            summary: '',
                            detail: msg
                        });
                        return;
                    }
                    this.datosCompletosTenencia = !this.datosCompletosTenencia
                    this.activeStep = this.activeStep + 1
                } else if (this.activeStep == 3) {
                    let validez = this.validarFormularioRepresentanteLegal()
                    if (!validez) {
                        console.log("validarFormularioTenencia has errors");
                        let msg = "";
                        if (this.draftProjectService.draftProject().tenenciaLegal == null || this.draftProjectService.draftProject().tenenciaLegal.length == 0) {
                            msg = "Representante legal es requerido"
                        } else {
                            msg = "Datos del representante legal son requeridos para continuar el proceso"
                        }
                        this.messageService.add({
                            severity: 'error',
                            summary: '',
                            detail: msg
                        });
                        return;
                    }
                    if (this.draftProjectService.draftProject().idTitular == undefined || this.draftProjectService.draftProject().idTitular === '' || this.draftProjectService.draftProject().idTitular === '0') {
                        this.messageService.add({
                            severity: 'error',
                            summary: '',
                            detail: "Titular es requerido"
                        });
                        return;
                    }
                    this.activeStep = this.activeStep + 1
                }
            }
        } else {
            this.activeStep = this.activeStep - 1
        }
        this.selectedComponent = this.stepComponents[this.activeStep];
        this.setStep(this.activeStep)
        this.personasService.limpiarSeleccion();
    }

    confirmarProyecto(confirmar: boolean) {
        if(this.draftProjectService.draftProject().montoInversion==null || this.draftProjectService.draftProject().montoInversion.toString()==""){
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: "Monto de inversión invalido"
            });
            return;
        }
        if (this.draftProjectService.verificarAchivosTenencia("completar") === 1 && !this.draftProjectService.checkSeleted()) {
            this.draftProjectService.isReloadFile.set(true);
            return;
        }

        this.confirmationService.confirm({
            message: ' El suscrito, en calidad de titular, propietario o representante legal de la sociedad\n' +
                '                                dueña del proyecto, doy fe de la veracidad de la información detallada en el presente\n' +
                '                                documento y anexos, cumpliendo con los requisitos de la ley exigidos, razón por la cual\n' +
                '                                asumo la responsabilidad consecuente derivada de esta declaración, que tiene calidad de\n' +
                '                                declaración jurada.',
            header: 'Declaración Jurada',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.procesar(confirmar);
            },
            reject: (type: ConfirmEventType) => {
                switch (type) {
                    case ConfirmEventType.REJECT:
                        break;
                    case ConfirmEventType.CANCEL:
                        break;
                }
            }
        });
    }

    procesar(confirmarPro: boolean) {
        this.showLoader = true
        this.progressDialog = true
        try {
            //Preparar session usuario actual
            const userSessionReq: UserSessionReq = {
                uniqueId: this.loginServices.session()?.perfil?.uniqueId,
                usuario: this.loginServices.session()?.perfil?.usuario,
                documento: this.loginServices.session()?.perfil?.documento,
                correo: this.loginServices.session()?.perfil?.correo
            };
            //Preparar archivos
            for (let i of this.draftProjectService.draftProject().tenenciaLegal) {
                i['idProyecto'] = this.idProyecto!
                const formData = new FormData();
                formData.append('idTipoArchivo', i.idTipoArchivo!.toString());
                formData.append('nombre', i.nombreArchivo!);
                formData.append('file', i.archivo!);
                formData.append('hash', i.hash!);
                formData.append('usuario', this.personasService.findContactoByTipo(i.personaInfo?.contactos!, 'EMAIL')?.contacto!);
                formData.append('idProyecto', '0');
                formData.append('idInstitucion', this.loginServices.session()?.perfil?.idInstitucion.toString()!);
                formData.append("idRequisito", i.idRequisito!.toString());
                formData.append("uniqueId", i.personaInfo?.uniqueId!);
                formData.append("correo", userSessionReq.correo!)
                formData.append("documento", userSessionReq.documento!)
                formData.append("caso", i.caso!)
                const fileItem: FileQueueItem = {
                    frm: formData,
                    hash: i.hash!,
                    progress: 0,
                    status: 'pending'
                };
                this.fileUtilsService.addItemToQueue(fileItem)
            }
            this.nuevoProyectoService.postProyecto(this.draftProjectService.draftProject())
                .subscribe({
                    next: (resp) => {
                        if (resp && resp.body) {
                            this.selected.set(resp.body)
                            //Setear idProyecto a los archivos previo a procesarlos.
                            this.fileUtilsService.fileQueue().forEach(preupload => {
                                preupload.frm.set('idProyecto', resp.body?.idProyecto.toString()!);
                            })
                            //Notificar en pantalla
                            this.messageService.add({
                                severity: 'success', summary: '', detail: 'Se ha guardado el proyecto correctamente'
                            });
                            //Reset status
                            this.showLoader = false
                            this.projectSaved = true
                            if (this.ubicacion != null) {
                                this.ubicacion.colindantes.set([])
                            }
                            this.tramite.idProyecto.set(`${this.idProyecto}`)// capturando idProyecto para cuando guarde el proyecto en seleccion libre
                            this.removeStep();
                            this.cleanSteps();

                            if (resp.status === 200) {
                                localStorage.removeItem("draftProject");
                                this.draftProjectService.draftProject.set(this.draftProjectService.resetDratfProject());
                            }
                        }
                    },
                    error: (error) => {
                        this.progressDialog = false
                        this.showLoader = false
                        this.messageService.add({
                            severity: 'error', summary: '', detail: 'Error al procesar solicitud'
                        });
                        console.log("error->", error)
                    }, complete: () => {
                        //Procesar archivos cuando finalice el procesamiento del proyecto
                        if(!this.draftProjectService.checkSeleted()){
                            this.onFileQueueProcessAll();
                        }
                    }
                });
        } catch (ex) {
            this.progressDialog = false
            this.showLoader = false
            this.messageService.add({
                severity: 'error', summary: '', detail: 'Error al procesar solicitud'
            });
            console.error(ex);
        }
    }

    onFileQueueProcessAll() {
        this.showLoader = true
        if (!this.fileUtilsService.fileQueue()) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'Archivos invalidos o no encontrados'
            });
            return;
        }
        this.fileUtilsService.fileQueue().forEach(preupload => {
            let idRequisito = Number.parseInt(<string>preupload.frm.get("idRequisito"));
            let idProyecto = Number.parseInt(<string>preupload.frm.get("idProyecto"));
            if (idRequisito == null || idRequisito == 0) {
                console.error(`idRequisito invalido para el archivo a procesar`)
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Archivos seleccionados no se encuentran vinculados a un requisito'
                });
                return;
            }
            if (idProyecto == null || idProyecto == 0) {
                console.error(`idProyecto invalido para el archivo a procesar`)
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Archivos seleccionados no se encuentran vinculados a un proyecto'
                });
                return;
            }
        })
        let fileUpload = this.fileUtilsService.fileQueue().filter(c1 => c1.frm.get('caso') === FileCase.FileUpload.toString());
        let reuseFile = this.fileUtilsService.fileQueue().filter(c2 => c2.frm.get('caso') === FileCase.ReuseFile.toString());
        if (fileUpload.length > 0) {
            fileUpload.forEach((file: FileQueueItem) => {
                console.log(`Processing file:${file.hash}`);
                let hashToProcess = <string>file.frm.get("hash");
                console.log("mostrandoifor file--->", file)
                this.fileUtilsService.upload(file)
                    .subscribe(
                        {
                            next: (result) => {
                                if (result) {
                                    if (result.status == 404 || result.status == 409) {
                                        this.duplicatedFileError()
                                        this.showLoader = false;
                                    }
                                    if (result.type === 'progress') {
                                        console.log(`#DEBUG Upload progress: ${result.progress}%`);
                                        this.tramite.updateProgressBarWithHash(file.hash, result.progress);
                                        if (result.progress == 100) {
                                            console.log('#DEBUG Upload done!!!')
                                        }
                                    } else if (result.type === 'response') {
                                        this.fileUtilsService.removeItemFromQueueByHash(hashToProcess.toString()!)//Remover de la cola cuando finalice la carga
                                        console.log(`#DEBUG Upload completed: ${JSON.stringify(result.body)}`);
                                        this.showLoader = false;
                                        this.messageService.add({
                                            severity: 'success', summary: '',
                                            detail: `[${file.frm.get("nombre")}] guardado correctamente`
                                        });
                                    }
                                }
                            },
                            error: (ex) => {
                                console.log("error al procesar archivos demasiados grandes", ex)
                                if (ex.error && ex.error.mensaje) {
                                    this.messageService.add({
                                        severity: 'error',
                                        summary: '',
                                        detail: ex.error.mensaje!
                                    });
                                }
                                if (ex.status == 413) {
                                    this.showLoader = false;
                                    this.messageService.add({
                                        severity: 'error',
                                        summary: '',
                                        detail: 'El archivo supera el tamaño máximo permitido de ' + this.fileUtilsService.maxFileSize / 250000000 + ' MB'
                                    });
                                }
                                this.showLoader = false;
                            },
                            complete: () => {
                                setTimeout(() => {
                                    if (this.fileUtilsService.fileQueue().length == 0) {
                                        this.fileUploadCompleted = true;
                                    }
                                }, 100);
                            }
                        }
                    )
            })
        }
        if (reuseFile.length > 0) {
            console.log('procesos de archivos reuseFile...');
            reuseFile.forEach((file: FileQueueItem) => {
                console.log(`Processing file:${file.hash}`);
                let hashToProcess = <string>file.frm.get("hash");
                this.fileUtilsService.uploadPersonas(file)
                    .subscribe(
                        {
                            next: (result) => {
                                if (result) {
                                    if (result.status == 404 || result.status == 409) {
                                        this.duplicatedFileError()
                                        this.showLoader = false;
                                    }
                                    if (result.type === 'progress') {
                                        console.log(`#DEBUG Upload progress: ${result.progress}%`);
                                        this.tramite.updateProgressBarWithHash(file.hash, result.progress);
                                        if (result.progress == 100) {
                                            console.log('#DEBUG Upload done!!!')
                                        }
                                    } else if (result.type === 'response') {
                                        this.fileUtilsService.removeItemFromQueueByHash(hashToProcess.toString()!)//Remover de la cola cuando finalice la carga
                                        console.log(`#DEBUG Upload completed: ${JSON.stringify(result.body)}`);
                                        this.showLoader = false;
                                        this.messageService.add({
                                            severity: 'success', summary: '',
                                            detail: `[${file.frm.get("nombre")}] guardado correctamente`
                                        });
                                    }
                                }
                            },
                            error: (ex) => {
                                console.log("error al procesar archivos demasiados grandes", ex)
                                if (ex.error && ex.error.mensaje) {
                                    this.messageService.add({
                                        severity: 'error',
                                        summary: '',
                                        detail: ex.error.mensaje!
                                    });
                                }
                                if (ex.status == 413) {
                                    this.showLoader = false;
                                    this.messageService.add({
                                        severity: 'error',
                                        summary: '',
                                        detail: 'El archivo supera el tamaño máximo permitido de ' + this.fileUtilsService.maxFileSize / 250000000 + ' MB'
                                    });
                                }
                                this.showLoader = false;
                            },
                            complete: () => {
                                setTimeout(() => {
                                    if (this.fileUtilsService.fileQueue().length == 0) {
                                        this.fileUploadCompleted = true;
                                    }
                                }, 100);
                            }
                        }
                    )
            })
        }
    }

    procesarOpcionalRq() {
        if (this.selected()?.idProyecto && this.projectSaved) {
            this.sdetTramiteService.updateEstadoOpcionalRq(this.selected()?.idProyecto!).subscribe(
                {
                    next: (result) => {
                        if (result) {
                            console.log(`updateEstadoOpcionalRq -> ${result}`);
                        }
                    },
                    error: (error) => {
                        console.log(error)
                    }
                }
            );
        }
    }
    async onFileUpload(event: any, persona: ProyectoPerfil) {
        const estado = await this.fileUtilsService.fileUploadToBuffer(event, this.fileUpload);
        this.hashDelArchivo = this.fileUtilsService.hash;
        if (estado != 1) {
            this.messageService.add({
                severity: 'error', summary: '',
                detail: 'Archivo no cargado, fallo el proceso de carga'
            });
            this.fileUpload.clear();
            return;
        }
        console.log("Resultado verificación:-> ", estado);
        this.agregarReloadFile(persona);
    }
    /**
     * Este metodo permite agregar de nuevo los archivos que se pertieron al recargar la pagina*/
    private agregarReloadFile(persona:ProyectoPerfil) {
        const existeHash = this.draftProjectService.draftProject().tenenciaLegal.some(item => item.hash === this.hashDelArchivo && item.pageRefresh == false);
        if (existeHash) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: "Ya existe este archivo seleccionado",
                showConfirmButton: true,
                timer: 3000
            }).then(r => console.error(r));
            this.fileUpload.clear();
            return;
        }

        //actualizando los datos solo del la personas que se selecciona cupliendo la condicion idPersona, idRequisito
        // esto para que solo se actualice los datos de la tenencia correctos
        this.draftProjectService.draftProject.update(draft => ({
            ...draft,
            tenenciaLegal: draft.tenenciaLegal.map(item =>
                (item.idPersona === persona.idPersona && item.idRequisito == persona.idRequisito) ?
                    {...item,
                        pageRefresh: false,
                        hash: this.hashDelArchivo,
                        nombreArchivo: this.fileUtilsService.file.name,
                        caso: 1,
                        archivo:this.fileUtilsService.file
                    } : item
            )
        }));
        this.draftProjectService.verificarAchivosTenencia("completar");
        this.fileUpload.clear();
    }
    public cleanSteps() {
        this.tenenciaSeleccionada = null;
        this.selectPlanosRequisito = null;
        this.personasService.limpiarSeleccion();
    }

    private duplicatedFileError(customError?: string) {
        let error = "Archivo ya existe en el proyecto especificado";
        if (customError) {
            error = customError;
        }
        Swal.fire({
            position: "center",
            icon: "error",
            title: error,
            showConfirmButton: true,
            timer: 2000
        }).then(r => console.error(error));
        this.showLoader = false;
    }

    fetchStep() {
        this.route.queryParams.subscribe(params => {
            const step = params['step'];
            if (step == undefined) {
                this.setStep(0)
            }
            if (step) {
                this.setStep(step)
            }
        });
    }

    fetchPasosFU() {
        this.frmService.getPasosFU()
            .subscribe({
                next: (result) => {
                    if (result) {
                        this.stepsFU.set(result!)
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
    }

    setStep(step: number) {
        if (step != undefined) {
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: {step: step},
                queryParamsHandling: 'merge',
            });
        }
    }

    removeStep() {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {},
            queryParamsHandling: 'merge',
        });
    }
    convertToJsonString(json: FieldPersonas<string>[]): string {
        return JSON.stringify(json, null, 2);
    }

    closeReloadFileDialog() {
        this.draftProjectService.isReloadFile.set(false);
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: Event): void {
        console.log('Page refresh detected');
        this.fileUtilsService.fileQueue.set([])
        this.draftProjectService.draftProject().idTitular='';
        this.showLoader = false;
        this.router.events.pipe(filter(revent => (revent instanceof NavigationStart) || (revent instanceof NavigationEnd)))
            .subscribe(() => {
                this.fileUtilsService.fileQueue.set([])
                this.showLoader = false;
            });
        this.draftProjectService.verificarAchivosTenencia("refreshPage");
        let pasoStatus:DraftStatus={idStepRefresh:this.activeStep+1,fecha:new Date()};
        localStorage.setItem("draftStatus", JSON.stringify(pasoStatus))
    }

    omitirCheckbox(event: any) {
        this.draftProjectService.checkSeleted.set(event.checked)
    }
    //TODO:Metodo de almacenar la informacion para localStorage, este metodo se procesa mediante senial de la variable signal que reaciona a los cambios usando  update o set
    //se comentario esta parte porque algunos elemento como dropdown, input etc, no actualiza el valor en el localStorage almomento de ingresar o se selecciona el valor
    // syncDraftProject = effect(() => {
    //     localStorage.setItem("draftProject", JSON.stringify(this.draftProjectService.draftProject()))
    //     console.log("#DEBUG draftProject saved!");
    // });
}
